import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SmsCfgService } from "./smsCfg.service";

class SmsPayload {
    constructor(message: string, phoneNumber: string) {
        this.message = message;
        this.phoneNumber = phoneNumber;
    }

    public message: string;
    public phoneNumber: string;
}

@Injectable({
    providedIn: "root"
})
export class SmsService {
    constructor(private cfgService: SmsCfgService, private httpClient: HttpClient) { }

    public async sendSms(message: string, phoneNumber: string) : Promise<void> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };

        let data = new SmsPayload(message, phoneNumber);

        let endpoint = this.cfgService.getCfg().endpoint;
        if (endpoint) {
            try {
                await this.httpClient.post<SmsPayload>(endpoint, data, httpOptions).toPromise();
            } catch (error) {
                console.log(error);
                throw error;
            }
        }
    }
}